/**
 * Alberenz A/B Testing Framework
 * --------------------------------
 * Variant assignment : localStorage (persistent per browser, 50/50)
 * Tracking           : GA4 via gtag() AND dataLayer (covers GTM setups)
 *
 * ACTIVE TEST: hero_static_v1
 *   Variant A (control)    : original auto-rotating slider (3s, 3 slides)
 *   Variant B (challenger) : static hero — autoplay off, only slide 1,
 *                            no dots / arrows / drag
 *
 * GA4 events:
 *   ab_test_impression  { ab_test_name, ab_variant }
 *   ab_test_click       { ab_test_name, ab_variant, element }
 * GA4 user property:
 *   ab_hero_static = 'a' | 'b'   (so purchases are segmentable by variant)
 *
 * DEBUG (browser console):
 *   ABTest.getVariant('hero_static_v1')        // see your variant
 *   ABTest.forceVariant('hero_static_v1','b')  // force B, then reload
 *   ABTest.forceVariant('hero_static_v1','a')  // force A, then reload
 *
 * NOTE: This file runs as a deferred <head> script, so it executes BEFORE
 * the GemPages carousel script (located later in the <body>) upgrades the
 * <gp-carousel-v3> custom element. That lets us safely edit gp-data first.
 */
(function () {
  'use strict';

  /* ─── Core helpers ──────────────────────────────────────────────── */
  function getVariant(testId) {
    var key = 'ab_' + testId;
    if (!localStorage.getItem(key)) {
      localStorage.setItem(key, Math.random() < 0.5 ? 'a' : 'b');
    }
    return localStorage.getItem(key);
  }

  function track(testId, eventName, extra) {
    var variant = getVariant(testId);
    var payload = { ab_test_name: testId, ab_variant: variant };
    if (extra) { for (var k in extra) { payload[k] = extra[k]; } }

    // GA4 (gtag.js)
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
    // GTM / dataLayer fallback
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      var d = { event: eventName };
      for (var k2 in payload) { d[k2] = payload[k2]; }
      window.dataLayer.push(d);
    }
  }

  var ABTest = {
    getVariant: getVariant,
    track: track,
    forceVariant: function (testId, variant) {
      localStorage.setItem('ab_' + testId, variant);
    }
  };
  window.ABTest = ABTest;

  /* ─── TEST: hero_static_v1 ──────────────────────────────────────── */
  var TEST = 'hero_static_v1';
  var CAROUSEL_ID = 'gcurIclR7Y';                 // GemPages carousel data-id
  var ROOT_ID = 'gp-root-carousel-' + CAROUSEL_ID;
  var variant = getVariant(TEST);

  /* Set GA4 user property so downstream events (incl. purchase) carry variant */
  if (typeof window.gtag === 'function') {
    window.gtag('set', 'user_properties', { ab_hero_static: variant });
  }

  /* VARIANT B — convert slider to static hero by editing gp-data
   * (runs at defer time, before the carousel custom element is defined). */
  if (variant === 'b') {
    try {
      var el = document.querySelector('gp-carousel-v3[data-id="' + CAROUSEL_ID + '"]')
            || document.getElementById(ROOT_ID);
      if (el && el.getAttribute('gp-data')) {
        var data = JSON.parse(el.getAttribute('gp-data'));
        var s = data.setting || {};
        s.autoplay = false;
        s.loop = s.loop || {};            s.loop.desktop = false;        s.loop.mobile = false;        s.loop.tablet = false;
        s.dot = s.dot || {};              s.dot.desktop = false;         s.dot.mobile = false;         s.dot.tablet = false;
        s.navigationEnable = s.navigationEnable || {}; s.navigationEnable.desktop = false; s.navigationEnable.mobile = false; s.navigationEnable.tablet = false;
        s.enableDrag = s.enableDrag || {}; s.enableDrag.desktop = false; s.enableDrag.mobile = false; s.enableDrag.tablet = false;
        data.setting = s;
        el.setAttribute('gp-data', JSON.stringify(data));
      }
    } catch (e) {
      /* If parsing fails, the CSS fallback below still hides controls */
    }
  }

  /* DOM-ready: CSS fallback (variant B) + impression + click tracking */
  document.addEventListener('DOMContentLoaded', function () {

    if (variant === 'b') {
      var style = document.createElement('style');
      style.textContent =
        '#' + ROOT_ID + ' .gp-carousel-arrow-' + CAROUSEL_ID + ',' +
        '#' + ROOT_ID + ' [class*="gp-carousel-dot"]{display:none !important;}';
      document.head.appendChild(style);
    }

    track(TEST, 'ab_test_impression', {});

    var root = document.getElementById(ROOT_ID);
    if (root) {
      root.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          track(TEST, 'ab_test_click', { element: 'hero_cta' });
        });
      });
    }
  });

})();
